import React from 'react';
import { Navigation } from './components/Navigation';
import { HeroSlide } from './slides/HeroSlide';
import { CSRvsSSRSlide } from './slides/CSRvsSSRSlide';
import { ThreeLayersSlide } from './slides/ThreeLayersSlide';
import { TrafficSourcesSlide } from './slides/TrafficSourcesSlide';
import { SEOvsAISEOSlide } from './slides/SEOvsAISEOSlide';
import { AdsSlide } from './slides/AdsSlide';
import { DelegateSlide } from './slides/DelegateSlide';
import { SocialProofSlide } from './slides/SocialProofSlide';
import { OnboardingSlide } from './slides/OnboardingSlide';
import { PricingSlide } from './slides/PricingSlide';
export function App() {
  return <div className="bg-dark min-h-screen text-white selection:bg-primary selection:text-white" data-id="element-0">
      <Navigation data-id="element-1" />

      <main className="flex flex-col" data-id="element-2">
        <HeroSlide data-id="element-3" />
        <ThreeLayersSlide data-id="element-4" />
        <TrafficSourcesSlide data-id="element-5" />
        <CSRvsSSRSlide data-id="element-6" />
        <SEOvsAISEOSlide data-id="element-7" />
        <AdsSlide data-id="element-8" />
        <DelegateSlide data-id="element-9" />
        <SocialProofSlide data-id="element-10" />
        <OnboardingSlide data-id="element-11" />
        <PricingSlide data-id="element-12" />
      </main>

      <footer className="bg-black py-8 text-center text-text-dim text-sm border-t border-white/5" data-id="element-13">
        <p data-id="element-14">© 2026 LetLois. All rights reserved.</p>
      </footer>
    </div>;
}